import type { FC } from 'react';
import type { AssessmentsAccumulationMappingsResponse } from '@/entities/assessments/api/generated/model';
import { BREADCRUMB_SEPARATOR, connectCodeAndName, connectProjectName } from '@/shared/lib/format';
import { Text } from '@/shared/ui';

type Props = {
  accumulationMappingsData: AssessmentsAccumulationMappingsResponse | undefined;
};

/**
 * 選択されたターゲットのヘッダーコンポーネント
 * タイトル（コード: 名称）とパンくずリストを表示
 */
export const TargetHeader: FC<Props> = ({ accumulationMappingsData }) => {
  const titleAndBreadcrumbItems = (() => {
    if (!accumulationMappingsData) {
      return null;
    }
    const projectName = connectProjectName({
      kan: accumulationMappingsData.kan,
      ko: accumulationMappingsData.ko,
      moku: accumulationMappingsData.moku,
      project_name: accumulationMappingsData?.project_name,
      project_code: accumulationMappingsData?.project_code,
    });
    const category1 = connectCodeAndName({
      name: accumulationMappingsData.project_category1_name,
      code: accumulationMappingsData.project_category1_code,
    });
    const category2 = connectCodeAndName({
      name: accumulationMappingsData.project_category2_name,
      code: accumulationMappingsData.project_category2_code,
    });
    const category3 = connectCodeAndName({
      name: accumulationMappingsData.project_category3_name,
      code: accumulationMappingsData.project_category3_code,
    });
    const names = [projectName, category1, category2, category3].filter(Boolean);

    const lastName = names.length > 0 ? names[names.length - 1] : '';
    const rest = names.length > 1 ? names.slice(0, names.length - 1) : [];

    return {
      title: lastName ?? '',
      breadcrumbItems: rest.join(BREADCRUMB_SEPARATOR),
    };
  })();

  return (
    <div className="space-y-2">
      <Text variant="subhead">{titleAndBreadcrumbItems?.title}</Text>
      <Text variant="description">{titleAndBreadcrumbItems?.breadcrumbItems}</Text>
    </div>
  );
};
